import { render, staticRenderFns } from "./replace.vue?vue&type=template&id=1bf3d8b2&scoped=true&"
import script from "./replace.vue?vue&type=script&lang=js&"
export * from "./replace.vue?vue&type=script&lang=js&"
import style0 from "./replace.vue?vue&type=style&index=0&id=1bf3d8b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf3d8b2",
  null
  
)

export default component.exports